import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ModalComponent} from "@app/shared/components";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {Tray} from "@models/tray.model";
import {TrayType} from "@models/enums/tray-type.enum";

@Component({
  selector: 'app-edit-tray-modal',
  templateUrl: './edit-tray-modal.component.html',
  styleUrls: ['./edit-tray-modal.component.scss']
})
export class EditTrayModalComponent {

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() dismissible = true;
    @Input() isLoading = false;

    @Output() cancelInfoModal = new EventEmitter<any>();
    @Output() editTray = new EventEmitter<any>();

    trayForm: UntypedFormGroup;
    showValidations = false;
    selectedTray;

    constructor(public translateService: TranslateService) {
        this.trayForm = new UntypedFormGroup({
            'name': new UntypedFormControl('', Validators.required),
            'forService': new UntypedFormControl(false)
        });
    }

    open(tray: Tray = null) {
        this.modal.open();
        this.selectedTray = tray;

        this.trayForm.get('name').setValue(tray ? tray.name : null);
        this.trayForm.get('forService').setValue(this.getForService());
    }

    close() {
        this.trayForm.reset();
        this.modal.close();
    }

    onCancel() {
        this.cancelInfoModal.emit();
    }

    onSaveSlot() {
        if (!this.trayForm.valid) {
            this.showValidations = true;
            return;
        }
        this.showValidations = false;

        const formData = Object.assign({}, this.trayForm.value);
        formData.id = this.selectedTray ? this.selectedTray.id : null;
        formData.trayType = this.trayForm.get('forService').value ? TrayType.Service : TrayType.Normal;

        this.editTray.emit(formData);
    }

    getForService() {
       if (!this.selectedTray) {
           return false;
       }

       if (TrayType.Service === this.selectedTray.trayType) {
           return true;
       }

       return false;
    }
}
